import { useEffect, useState } from "react";
import { selectCommunicationData } from "../../store";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { Vspace } from '../../components/styled/Separators.style'
import { LIconContainer } from "../../components/styled/Icon.style";
import PageContainerCmp from "../PageContainerCmp";
import { RealtimeModal } from "../../components/modal/RealtimeModal";
import { saveCommunicationAct } from "../../store/communication-data/actions";
import { EventCommType, EventValueEnum } from "../../types/communication/communicationDataType";
import { LINEAR_BASE_ROUTE, LINEAR_PATHS } from "../../routes/linearRouteConstants";
import { LPageTitle, LSimpleText } from "../../components/styled/Text.style";
import { LNextButton } from "../../components/styled/Button.style";
import { Section, LTitleIconSection } from "../../components/styled/Containers.style";
import LinearFooterCmp from "../../components/footer/LinearFooter";
import { LinearInfoModal } from "../../components/cai-info-modal/LinearInfoModal";
import CaiPreviewsCmp from "../../components/cai-preview/CaiPreviewsCmp";
import { composeUrl } from "../../utils/utils";
import { useNavigate, useSearchParams } from "react-router-dom";
import linearInfo from '../../assets/img/linear_info.svg';
import SinistroCardLinear from "../../components/cards/SinistroCardLinear";

const CaiPresentationPageLinear = () => {
    const dispatch = useAppDispatch();
    const [openLoadDocumentsModal, setOpenLoadDocumentsModal] = useState(false)
    const [openInfoModal, setOpenInfoModal] = useState(false)
    const communicationData = useAppSelector(selectCommunicationData)
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { communication } = communicationData
    const { token, caiData } = communication;

    const isForcedPath = !!caiData?.data?.vehicleA?.driver?.telNumber

    const previewUrlPage_1 = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}/dinamica-attachment-cai-data/full-page`;
    const previewUrlPage_2 = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}/dinamica-attachment-cai-data/second-full-page`;

    const goToNextStepHandler = () => {
        const nextPath = composeUrl(token, LINEAR_PATHS.QUESTION_AGREEMENT_PAGE, LINEAR_BASE_ROUTE)
        navigate(nextPath)
    }

    const goToLoadDocuments = () => {
        const newEvent = new EventCommType({ value: EventValueEnum.LINEAR_IGNORED_CAI });
        const nextPath = composeUrl(token, LINEAR_PATHS.REQUIRE_DOCUMENTS_PAGE, LINEAR_BASE_ROUTE)
        dispatch(saveCommunicationAct({
            events: [newEvent],
            callback: () => {
                navigate(nextPath)
            }
        }));
    }

    useEffect(() => {
        const docParam = searchParams.get('doc');
        if (docParam === 'true') {
            // Rimuovi sempre il parametro 'doc' dalla query string
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.delete('doc');
            setSearchParams(newSearchParams);
        }
        const newEvent = new EventCommType({ value: EventValueEnum.LINEAR_COMMUNICATION_OPENED });
        const newEvent2 = new EventCommType({ value: EventValueEnum.LINEAR_CAI_PRESENTATION_SHOW });
        let isFirstPage = false;
        if (!communication.events.find(ev => ev.value === EventValueEnum.LINEAR_COMMUNICATION_OPENED)) {
            isFirstPage = true;
        }
        dispatch(saveCommunicationAct({
            events: isFirstPage === true ? [newEvent, newEvent2] : [newEvent2],
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <RealtimeModal
                companyName={communication?.companyName}
                modalOpened={openLoadDocumentsModal}
                hTitle="INOLTRA COMUNICAZIONE"
                hCloseButton={true}
                /* istanbul ignore next */
                onCloseHandler={() => setOpenLoadDocumentsModal(false)}>
                <LinearInfoModal
                    text={"Inviaci la tua copia cartacea della Constatazione Amichevole d'Incidente e altri documenti utili."}
                />
            </RealtimeModal>

            <RealtimeModal
                companyName={communication?.companyName}
                modalOpened={openInfoModal}
                hTitle="MODULO DI CONSTATAZIONE AMICHEVOLE DIGITALE"
                hCloseButton={true}
                /* istanbul ignore next */
                onCloseHandler={() => setOpenInfoModal(false)}>
                <LinearInfoModal
                    text={"È il modulo di denuncia del sinistro in formato digitale: lo trovi compilato con le informazioni del tuo sinistro. Verifica i dati e procedi con la firma digitale."}
                />
            </RealtimeModal>

            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={LINEAR_PATHS.CAI_PRESENTATION_PAGE}
                removeNextBtn
                isForceLastPathname={isForcedPath}
            >

                <Section linear={true}>

                    <SinistroCardLinear />

                    <Vspace qty={2}></Vspace>

                    <LTitleIconSection>
                        <LPageTitle>MODULO DI CONSTATAZIONE AMICHEVOLE</LPageTitle>
                        <LIconContainer onClick={() => setOpenInfoModal(true)}>
                            <img
                                src={linearInfo}
                                alt="Icon Info"
                                style={{ width: "23px" }}
                            />
                        </LIconContainer>
                    </LTitleIconSection>

                    <Vspace qty={2}></Vspace>

                    <LSimpleText>Visualizza la tua <strong style={{ color: "#575757" }}>Constatazione Amichevole d'Incidente in formato digitale</strong> e, se i dati sono corretti, procedi con la firma digitale. </LSimpleText>

                </Section>

                <Vspace qty={2}></Vspace>

                <Section linear={true}>
                    <CaiPreviewsCmp
                        previewUrlPage_1={previewUrlPage_1}
                        previewUrlPage_2={previewUrlPage_2}
                        isCaiSecondPageVisible={!!communication?.previewSecondPageVisible}
                    ></CaiPreviewsCmp>
                </Section>

                <Vspace qty={2}></Vspace>

                <Section linear={true}>
                    <LNextButton onClick={goToNextStepHandler}>PROCEDI CON LA FIRMA</LNextButton>
                    <Vspace qty={2}></Vspace>
                    <LSimpleText style={{ margin: "0 20px" }}>Hai compilato la CAI cartacea o riscontri errori? Carica la copia corretta e i documenti integrativi.</LSimpleText>
                    <Vspace qty={2}></Vspace>
                    <LNextButton inverted={true} onClick={goToLoadDocuments}>CARICA DOCUMENTI</LNextButton>
                </Section>

                <LinearFooterCmp />

            </PageContainerCmp>
        </>

    )
}

export default CaiPresentationPageLinear